import React from 'react'

import { theme } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import { SECTION_ICON_CONTAINER } from 'utils/testing/testIDs'

import { fonts } from '../../styles'

const SectionIconContainer = styled.p`
  ${fonts.AN_14_600_22}
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 100px;
  display: flex;
  height: 30px;
  justify-content: start;
  width: fit-content;
`

const SectionNumber = styled.span`
  align-items: center;
  background: ${theme.colors.white};
  border-radius: 100px;
  display: flex;
  flex-direction: column;
  height: 30px;
  justify-content: center;
  padding: 4px 8px;
  width: 30px;
`

const SectionName = styled.span`
  color: ${theme.colors.white};
  display: flex;
  padding-left: 10px;
  padding-right: 20px;
  text-align: center;
`

const sectionMap = [
  'early.recap.contributions.title',
  'early.recap.gifts.title',
  'early.recap.performance.title',
  'early.recap.potential.title',
]

const SectionIcon = ({
  sectionIndex,
}: {
  sectionIndex: number
}): React.ReactElement => {
  const { getRemoteString } = useRemoteStrings()

  const title = getRemoteString({ key: sectionMap[sectionIndex] })

  return (
    <SectionIconContainer data-testid={SECTION_ICON_CONTAINER}>
      <SectionNumber>{sectionIndex + 1}</SectionNumber>
      <SectionName>{title}</SectionName>
    </SectionIconContainer>
  )
}

export { SectionIcon }
